import { getAccessTokenFromCookie } from "../../util/authentication";
import { CFG_EMP, SYSTEM_API_COMMON_CONFIG } from "../../util/constants";

export const getGOpsJobCodes = async () => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API +
    SYSTEM_API_COMMON_CONFIG +
    "/" +
    CFG_EMP.NAME +
    "/" +
    CFG_EMP.GO +
    "/" +
    CFG_EMP.JOB_CODE;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getGOpsJobCodesList = async () => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API +
    SYSTEM_API_COMMON_CONFIG +
    "/" +
    CFG_EMP.NAME +
    "/" +
    CFG_EMP.GO +
    "/" +
    CFG_EMP.JOB_CODE +
    "/" +
    CFG_EMP.LIST;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getGOpsJobCode = async (jobCode) => {
  const apiEndpoint =
    process.env.REACT_APP_SYSTEM_SERVICE_API +
    SYSTEM_API_COMMON_CONFIG +
    "/" +
    CFG_EMP.NAME +
    "/" +
    CFG_EMP.GO +
    "/" +
    CFG_EMP.JOB_CODE +
    "/" +
    jobCode;
  try {
    const response = await fetch(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + getAccessTokenFromCookie(),
      },
    });
    return response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
};
